import React, { memo, useCallback, useMemo } from "react";
import Button from "../../../../../../shared-components/css-modules/toyota/atoms/Button";
import Icon from "../../../../../../shared-components/css-modules/toyota/atoms/Icon";
import a11y from "../../../../../../shared-components/css-modules/toyota/utils/Accessibility.module.scss";
import styles from "../ConfigCtas.module.scss";
import { trackClickSideDisplayToyotaCode } from "../../../../../utils/tracking";
import Popover from "../../../../../../shared-components/css-modules/toyota/vendor/popover/Popover";
import { useCarConfigSelector } from "../../../../../redux/store";
import Tooltip from "../../../../../../shared-components/css-modules/toyota/vendor/tooltip/Tooltip";
import Text from "../../../../../../shared-components/css-modules/toyota/atoms/Text";
import { CarConfigLabel } from "../../../../../utils/labelUtils";

const TyCode: React.FC = () => {
    const save = useCarConfigSelector((state) => state.save);
    const section = useCarConfigSelector((state) => state.carConfigNavigation.activeSection);

    const tyCode = save?.data?.Personal?.Code || save?.data?.ConfigurationCode || "";

    const onClick = useCallback(
        (isOpen: boolean) => {
            if (isOpen) {
                trackClickSideDisplayToyotaCode(section);
            }
        },
        [section],
    );

    return useMemo(
        () =>
            tyCode ? (
                <Popover placement="left" onOpenChangeListen={onClick}>
                    <Tooltip placement="left">
                        <Popover.Trigger>
                            <Tooltip.Trigger>
                                <Button variant="clean" className={styles.link}>
                                    <Icon variant="my-toyota" sizing="md" aria-hidden="true" />
                                    <span className={a11y["sr-only"]}>
                                        <CarConfigLabel label="carConfigActionsTyCodeButtonLabel" />
                                    </span>
                                </Button>
                            </Tooltip.Trigger>
                        </Popover.Trigger>
                        <Popover.Content variant="action-panel">
                            <div>
                                <header className={styles.tyheader}>
                                    <Text variant="body-book">
                                        <CarConfigLabel label="carConfigActionsTyCodeTitle" />
                                    </Text>
                                    <Popover.Close>
                                        <Button variant="clean">
                                            <Icon variant="close" sizing="md" aria-hidden="true" />
                                            <span className={a11y["sr-only"]}>
                                                <CarConfigLabel label="carConfigTooltipClose" />
                                            </span>
                                        </Button>
                                    </Popover.Close>
                                </header>

                                <Text
                                    variant="apheleia-h2"
                                    tag="div"
                                    spacing="spacing-3"
                                    className={styles.code}
                                    onClick={() => {
                                        navigator.clipboard.writeText(tyCode);
                                    }}
                                >
                                    {tyCode}
                                </Text>
                                <Text variant="apheleia-body">
                                    <CarConfigLabel label="carConfigActionsTyCodeText" />
                                </Text>
                            </div>
                        </Popover.Content>
                        <Tooltip.Content className={styles.popover}>
                            <CarConfigLabel label="carConfigActionsTyCodeButtonLabel" />
                        </Tooltip.Content>
                    </Tooltip>
                </Popover>
            ) : null,
        [tyCode],
    );
};

export default memo(TyCode);
